import axios from '@/lib/axios';
import { InvoiceTask, SalesOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1841. 請求タスクアーカイブ解除
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:id/unarchive
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};
const unarchiveInvoiceTasks = (props: Props): Promise<InvoiceTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.id}/unarchive`,
    props
  );
};

export const useUnarchiveInvoiceTasks = () => {
  return useMutation({
    mutationFn: unarchiveInvoiceTasks,
  });
};
